import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  addAditionalNote,
  addDiagnoseNote,
  addDiagnoses,
} from "../../../../../../../../redux/diagnosestate/diagnoseAction";
import TreatTraw from "./TreatTraw";
import { RootState } from "../../../../../../../../redux/store";
import baseUrl from "../../../../../../../../api/baseUrl";

function Treatdiagnose({ adult }: { adult: boolean }) {
  const dispatch = useDispatch();
  const teeth = useSelector((state: RootState) => state.diagnose.diagnoseTooth);
  const { ID } = useParams();
  useEffect(() => {
    baseUrl
      .get("treatment/find-treatment", {
        headers: {
          treatmentid: ID,
        },
      })
      .then((response) => {
        dispatch(addAditionalNote(response.data.data.aditionalNote));
        dispatch(addDiagnoseNote(response.data.data.patientComplain));
        dispatch(addDiagnoses(response.data.data.diagnose));
      })
      .catch((error) => {
        console.log(error);
      });
  }, [ID,dispatch]);

  return (
    <div className="bg-white rounded-[8px] shadow-lg shadow-slate-200/50 border border-slate-100 overflow-hidden">
    <div className="px-4 py-2.5 border-b border-slate-200">
      <h3 className="text-sm font-bold text-slate-800">Diagnosis Table</h3>
    </div>
    <div className="p-3 overflow-x-auto">
    <table className="w-full">
      <thead>
        <tr className="bg-slate-50">
          <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider">Diagnose</th>
          <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider">Tooth No</th>
          <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider">Surface</th>
          <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider">Note</th>
          <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider">Priority</th>
          <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider">Est. Time</th>
          <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider">Action</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-slate-100">
        {teeth
          .filter((item: any) => item.adult === adult)
          .flatMap((item: any, i: number) => (
            <TreatTraw item={item} key={i} />
          ))}
      </tbody>
    </table>
    </div>
    </div>
  );
}

export default Treatdiagnose;
